@if (routeData$ | async; as routeData) {
  @if (!hash || routeData.trip) {
    @if (routeData.experience; as experience) {
      <div [ngClass]="{insiders: experience.styleSlug === ExperienceStyle.INSIDERS}" class="experience">
        <section class="ess-experience-header">
          <ess-experience-header
            [title]="experience.title"
            [date]="experience.date"
            [time]="experience.time"
            [scrollRatio]="(scrollRatio$ | async) ?? 0"
            [titleVisible]="(titleVisible$ | async) ?? false"
            [id]="id"
            [hash]="hash"
            [status]="experience.statusSlug"
            (backEvent)="onBackEvent()"
            [isBookingExperience]="experience.isBookingExperience"
            [isMobileResolution]="(isMobileResolution$ | async) ?? false"
            [scroll$]="scroll$"
            [headerBG]="headerBG$ | async"
            [isSampleTrip]="!!hash && !!routeData.trip?.isSample"
            role="banner"
          />
        </section>
        <section class="experience-container" role="main">
          <section class="ess-experience-title">
            <ess-experience-title
              [benefits]="experience.benefits"
              [category]="experience.category"
              [city]="experience.address.city"
              [neighborhood]="experience.address.neighborhood"
              [experienceStyle]="experience.styleSlug"
              [title]="experience.title"
              (titlePosition)="onTitlePosition($event)"
            />
          </section>
          <section #gallerySection class="ess-experience-gallery">
            @if (experience.gallery.length) {
              <ess-experience-gallery [gallery]="experience.gallery" [title]="experience.title" />
            }
          </section>
          <section class="separator first">
            <div></div>
          </section>
          <section class="ess-experience-editor-view">
            @if (experience.editorialContent.length || experience.tags.length || experience.description) {
              <ess-experience-editor-view
                [benefits]="experience.benefits"
                [description]="experience.description"
                [editorialContent]="experience.editorialContent"
                [experienceStyle]="experience.styleSlug"
                [tags]="experience.tags"
              />
            }
          </section>
          @if (experience.quote) {
            <section #editorTipsSection class="ess-experience-editor-tips">
              <ess-experience-editor-tips [quote]="experience.quote" [experienceStyle]="experience.styleSlug" />
            </section>
          }
          @if (experience.whatWeLoveGallery.length) {
            <section class="ess-experience-love-slideshow">
              <ess-experience-love-slideshow [whatWeLoveGallery]="experience.whatWeLoveGallery" />
            </section>
            <section class="separator second">
              <div></div>
            </section>
          }
          @if (
            ((experience.styleSlug === ExperienceStyle.SELF_EXPLORE && !experience.related.length) ||
              experience.styleSlug !== ExperienceStyle.SELF_EXPLORE) &&
            (experience.address.location || experience.address.full_address)
          ) {
            <section class="ess-experience-map">
              <ess-experience-map [address]="experience.address" [icon]="experience.icon" />
            </section>
          }
          @if (experience.styleSlug === ExperienceStyle.SELF_EXPLORE && experience.related.length) {
            <section class="ess-self-explore-map">
              @if ((isMobileResolution$ | async) === false) {
                <ess-experience-self-explore-desktop [relatedExperiences]="experience.related" />
              }
              @if (isMobileResolution$ | async) {
                <ess-experience-self-explore-mobile [relatedExperiences]="experience.related" />
              }
            </section>
          }
          @if (experience.insiders.length) {
            <section class="ess-experience-insiders">
              <ess-experience-insiders [insiders]="experience.insiders" />
            </section>
          }
        </section>

        <section class="ess-footer">
          <ess-footer [showTerms]="false" role="contentinfo" />
        </section>
      </div>
    }
  }
}
